import { FaBars } from "react-icons/fa";

export const navList = [
  {
    nav: "Dashboard",
    icon: <FaBars />,
    dir: "/",
  },
  {
    nav: "Videos",
    icon: <FaBars />,
    dir: "/videos",
  },
  {
    nav: "Tasks",
    icon: <FaBars />,
    dir: "/tasks",
  },
  {
    nav: "Users",
    icon: <FaBars />,
    dir: "/users",
  },
  {
    nav: "Account",
    icon: <FaBars />,
    dir: "/account",
  },
];
